import { centsToDollarsDisplay } from "../../../components/displayFormatters"
import { formatRatePercent } from "../taxRate"
import { SurchargeMethodTerms } from "./surchargeTerms"

export const surchargeCostText = (terms: SurchargeMethodTerms): string | null => {
  if (terms.costRate === null) {
    return null
  }
  const cap = terms.rateCapCents !== null ? ` (max ${centsToDollarsDisplay(terms.rateCapCents)})` : ''
  const fee = terms.fixedFeeCents ? ` + ${centsToDollarsDisplay(terms.fixedFeeCents)}` : ''
  return `${formatRatePercent(terms.costRate)}${cap}${fee}`
}

export const surchargeMaximumText = (terms: SurchargeMethodTerms): string | null => {
  if (!terms.allowed) {
    return null
  }
  if (!terms.fixedFeeCents || terms.maximumSurchargeRate >= terms.capRate) {
    return `Up to ${formatRatePercent(terms.maximumSurchargeRate)}`
  }
  return `Up to ${formatRatePercent(terms.maximumSurchargeRate)} + ${centsToDollarsDisplay(terms.fixedFeeCents)}, never more than ${formatRatePercent(terms.capRate)}`
}

export const surchargeBlockedReason = (card: SurchargeMethodTerms, bank: SurchargeMethodTerms): string | null => {
  if (card.allowed || bank.allowed) {
    return null
  }
  return card.unavailableReason ?? bank.unavailableReason ?? "Passing on payment fees isn't available for your account."
}
